var map = {
	"./en/about.json": "38a0",
	"./en/artist.json": "af74",
	"./en/bridge.json": "f4b0",
	"./en/button.json": "2a15",
	"./en/claim.json": "dd21",
	"./en/event.json": "18c9",
	"./en/features.json": "18f0",
	"./en/gallery.json": "ceb7",
	"./en/guide.json": "6988",
	"./en/home.json": "7212",
	"./en/loading.json": "e005",
	"./en/login.json": "ca7b",
	"./en/menu.json": "34de",
	"./en/meta.json": "6572",
	"./en/mypage.json": "04a1",
	"./en/nftpool.json": "0412",
	"./en/pacepool.json": "98d2",
	"./en/payment.json": "4602",
	"./en/product.json": "8cc2",
	"./en/stake.json": "d712",
	"./en/validation.json": "c2ed",
	"./en/wallet.json": "1799",
	"./ko/about.json": "efe0",
	"./ko/artist.json": "c7f4",
	"./ko/bridge.json": "a7b0",
	"./ko/button.json": "923b",
	"./ko/claim.json": "9600",
	"./ko/event.json": "95ef",
	"./ko/features.json": "e861",
	"./ko/gallery.json": "e7bc",
	"./ko/guide.json": "26bc",
	"./ko/home.json": "927a",
	"./ko/loading.json": "26c6",
	"./ko/login.json": "de71",
	"./ko/menu.json": "b05a",
	"./ko/meta.json": "9007",
	"./ko/mypage.json": "fd14",
	"./ko/nftpool.json": "108e",
	"./ko/pacepool.json": "60620",
	"./ko/payment.json": "e3d9",
	"./ko/product.json": "b3d4",
	"./ko/stake.json": "4427",
	"./ko/validation.json": "4578",
	"./ko/wallet.json": "a5bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4999";